import { MenuItem } from "../../Types/Layout/SidebarType";

export const ClothMenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "home",
        type: "link",
        lanClass: "lan-3",
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
      },
    ],
  },
  {
    title: "Applications",
    lanClass: "lan-8",
    Items: [
      {
        title: "Ticket Booking",
        id: 3,
        icon: "project",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/cloth/cloth_assign`, type: "link", title: "Cloth Assign" },
          { path: `${process.env.PUBLIC_URL}/cloth/all_cloth_assign`, type: "link", title: "All Cloth Assign" },
        ],
      },
    ],
  },
];
